import { render, staticRenderFns } from "./industrial_development.vue?vue&type=template&id=1e1a22d8&scoped=true&"
import script from "./industrial_development.vue?vue&type=script&scoped=true&lang=js&"
export * from "./industrial_development.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./industrial_development.vue?vue&type=style&index=0&id=1e1a22d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a22d8",
  null
  
)

export default component.exports